<template>
  <div class="statistics">
    <div class="stat">
      <span class="stat-label">Vaginal bleeding today: </span>

      <span class="stat-stat">
        {{ getVaginalBleedingValueName(existingEntry.data.vaginalBleeding) }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">Time to saturate a pad or tampon today:</span>

      <span class="stat-stat">
        {{ getSaturationValueName(existingEntry.data.saturation) }}
      </span>
    </div>
  </div>
</template>

<script>
import Bleeding from "../../../mixins/modules/bleeding.js";

export default {
  name: "Stats",
  mixins: [Bleeding],
  props: ["existingEntry"],
};
</script>

<style></style>
